import { render, staticRenderFns } from "./CompanyLogoBudget.vue?vue&type=template&id=13b86a4e&"
import script from "./CompanyLogoBudget.vue?vue&type=script&lang=js&"
export * from "./CompanyLogoBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports